import Airtable from 'airtable';

// api keys are confidential
const base = new Airtable({ apiKey: 'keyMOMSwpSuoFnwrV' }).base(
  'appdOOFWxBmb7Maeq'
);

export default base;
